import { useId, useContext} from "react";
import './input-toggle.css'
import { clsx } from "../../functions.ts";
import { inputOnKeyUp } from "../../functions.ts";
import { ConfigContext } from "../../config_context.ts";

export default function ToggleInputRadio (props: {
	label: string,
	value: boolean,
  image: string,
  onChange: (value: boolean) => void,
}){
  const id = useId();
  const base_asset_url = useContext(ConfigContext).base_asset_url; 
  return <div 
          role="radio"
          aria-checked={props.value}
          aria-labelledby={id+"-label"}
          className={"toggle-input"}
          id={id}
          onClick={()=>{props.onChange(!props.value);}}
          onKeyUp={(event)=> inputOnKeyUp(event, ()=>{ props.onChange(!props.value); })}
          tabIndex={0}
        >
        <div 
          aria-hidden
          style={{backgroundImage: "url("+base_asset_url+props.image+")"}} 
          className={clsx("toggle-input__button", props.value && "toggle-input__button--active")} 
        />
        <label aria-hidden className={"toggle-input__label input__label"} id={id+"-label"} htmlFor={id}>
          {props.label}
        </label>
    </div>
}